import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Layout from '../../components/common/pageLayout';
import ExpenseEntryForm from '../../components/expense/submitExpense';
import constant from '../../constant';  
import { toast } from 'react-toastify';
import { v3_add_expense_entry } from '../../actions/v3/expenses'; // ✅ create this action
import { v2_get_expense_types, v2_siteLocations } from '../../actions/v2/masterData'; // ✅ assuming this already exists

const AddExpenseEntry = () => {
    const history = useHistory();
    const [expenseTypes, setExpenseTypes] = useState([]);
    const [siteLocations, setSiteLocations] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchExpenseTypes = async () => {
        const res = await v2_get_expense_types();
        if (res.status) {
            setExpenseTypes(res.result || []);
        } else {
            toast.error('Failed to load expense types');
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchExpenseTypes();
        v2_siteLocations().then((res) => {
            if (res.status) {
                setSiteLocations(res.result || []);
            }
        });
    }, []);

    const onSubmit = async (model) => {
        try {
            const res = await v3_add_expense_entry(model);
            if (res.status) {
                toast.success(res.result.message || 'Expense entry submitted successfully!');
                history.push(constant.Authedcomponent.expenseList.url); // ✅ update route in constants
            } else {
                toast.error(res.error || 'Something went wrong!');
            }
        } catch (err) {
            toast.error('Server error while submitting expense entry.');
            console.error(err);
        }
    };

    return (
        <Layout title="Add Expense Entry">
            {loading ? (
                <div>Loading expense types...</div>
            ) : (
                <ExpenseEntryForm
                    title="Add Expense Entry"
                    onSubmit={onSubmit}
                    expenseTypes={expenseTypes}
                    siteLocations={siteLocations}
                />
            )}
        </Layout>
    );
};

export default AddExpenseEntry;
